import { useMemo } from 'react';
import type { Region } from '@/api/regions';
import { estimateCountry } from '@/lib/estimateCountry';
import { useGeoCountry } from './useGeoCountry';

/**
 * 居住地の初期値の推定結果。推定中・推定不能なら null。
 * /geo はタイムアウト付きで必ず決着するため、待っている間だけ null になる。
 */
export function useCountryEstimate(regions: readonly Region[] | undefined): string | null {
  const geo = useGeoCountry();

  return useMemo(() => {
    if (!regions || geo.isPending) {
      return null;
    }
    return estimateCountry({
      // 失敗 (geo.isError) は data が undefined になり、ロケールでの推定に進む
      geoCountry: geo.data ?? null,
      languages: navigator.languages ?? [],
      regionCodes: new Set(regions.map((r) => r.code)),
    });
  }, [regions, geo.isPending, geo.data]);
}
